namespace SPA
{
	export namespace BWS
	{
		export namespace data
		{

			export class BWSHistorieTableDataReader
				extends ui.table.DataReader< Wollmilch.BWS.IBWS >
			{
				public constructor()
				{
					super();
				}

				public GenerateDataField( BWSData: any ): JQuery<HTMLElement>
				{
					const link = $(
						new Button(
							{
								on:
								{
									click: () =>
									{
										new Wollmilch.AJAX(
										{
											method: 'GET',
											on:
											{
												success: ( text: string ) =>
												{
													const obj = Wollmilch.jsonize( text );

													if ( !obj || obj.success === false )
													{
														return;
													}

													const srcStr = 'data:' + obj.data.MimeType + ';' + ( obj.data.Base64 ? 'base64,' : '' );

													let modal: ui.dialog.Modal;

													const imgType: any = ui.$$.iframe();

													modal = new ui.dialog.Modal(
													{
														body: [ imgType.attr( 'src', srcStr + obj.data.Blob ) ],
														css:
														{
															cursor: 'zoom-out',
														},
														noCloseBtn: true,
														size: 'lg',
													} );
													modal.on( 'click', () => modal.Hide() );
												},
											},
											url: 'artifact/download/' + BWSData.artifactID,
										},
										).send();

									},
								},
								style: 'link',
								title: 'anzeigen',
							},
						).getElement(),
					).removeClass( 'btn' );

					const btnDownload = ui.$$.button()
					.on( 'click',
					() =>
					{
						new Wollmilch.AJAX(
						{
							method: 'GET',
							on:
							{
								success: ( text: string ) =>
								{
									const obj = Wollmilch.jsonize( text );

									if ( !obj || obj.success === false )
									{
										return;
									}

									const srcStr = 'data:' + obj.data.MimeType + ';' + ( obj.data.Base64 ? 'base64,' : '' );

									let modal: ui.dialog.Modal;

									const imgType: any = ui.$$.iframe().attr( 'height', '600px' );

									modal = new ui.dialog.Modal(
									{
										body:
										[
											imgType.attr( 'src', srcStr + obj.data.Blob ),
											imgType.attr( 'width', '100%' ),
										],
										css:
										{
											cursor: 'zoom-out',
										},
										noCloseBtn: true,
										size: 'lg',
									} );
									modal.on( 'click', () => modal.Hide() );
								},
							},
							url: 'artifact/download/' + BWSData.artifactID,
						},
						).send();

					},
				 	)
					.append( ui.$$.span().addClass( 'fas fa-download' ) )
					.addClass( 'btn btn-default' )
					.css(
						{
							height:	'34px',
							margin:	'3px',
							width:	'39px',
						},
					);

					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( BWSData.keydate ? BWSData.keydate : '' ),
						)
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( BWSData.rating ? BWSData.rating.valuedetermination : '' ),
						)
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( ( BWSData.rating ? BWSData.rating.realvalue.toString().replace( '.', ',' ) : '-' )
								+ app.getMessage( 'BWS.TABLE.eur' ) ),
						)
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( ( BWSData.rating ? BWSData.rating.earningrate.toString().replace( '.', ',' ) : '-' )
								+ app.getMessage( 'BWS.TABLE.eur' ) ),
						)
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( ( BWSData.rating ? BWSData.rating.referencevalue.toString().replace( '.', ',' ) : '-' )
								+ app.getMessage( 'BWS.TABLE.eur' ) ),
						)
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( btnDownload ) )
					.Root();
				}

			}

		}
	}
}
